import { createContext, useCallback, useContext, useMemo, useState, type ReactNode } from "react";

type BookingContextValue = {
  open: boolean;
  openBooking: () => void;
  closeBooking: () => void;
};

const BookingContext = createContext<BookingContextValue | null>(null);

export function BookingProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);

  // Prefer the full availability-request page over the legacy modal preview.
  const openBooking = useCallback(() => {
    if (typeof window !== "undefined") {
      const path = window.location.pathname;
      if (path === "/reservations" || path === "/reservations/") {
        document.getElementById("availability-request")?.scrollIntoView({ behavior: "smooth" });
        return;
      }
      window.location.assign("/reservations/");
      return;
    }
    setOpen(true);
  }, []);

  const closeBooking = useCallback(() => setOpen(false), []);
  const value = useMemo(() => ({ open, openBooking, closeBooking }), [open, openBooking, closeBooking]);
  return <BookingContext.Provider value={value}>{children}</BookingContext.Provider>;
}

export function useBooking() {
  const ctx = useContext(BookingContext);
  if (!ctx) throw new Error("useBooking must be used inside BookingProvider");
  return ctx;
}
